// extracted by mini-css-extract-plugin
export default {"root":"reseller_details_root__ICByM","row":"reseller_details_row__eaeGd"};